import About from './about'

export default [{
    path: '/about',
    name:'about',
    component:About
}]